import { observable } from '/builds/gitlab/gitlab-ee/app/assets/javascripts/lib/utils/observable.js?vue3';

export const hashState = observable('blob_hash_state', {
  currentHash: window.location.hash,
});

export const updateHash = (newHash) => {
  hashState.currentHash = newHash;
};
